import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(({ spacing }) => ({
  modalContent: {
    display: "flex"
  },
  modalTitle: {
    paddingRight: spacing(3)
  },
  titleContent: {
    marginLeft: "auto"
  },
  controlsContainer: {
    display: "flex",
    alignItems: "center"
  },
  imageContainer: { width: "100%", display: "flex" },
  image: {
    height: "100%",
    width: "100%",
    objectFit: "contain"
  },
  draggable: {
    cursor: "grab",

    "&:active": {
      cursor: "grabbing"
    }
  },
  caption: { display: "none" }
}))
